import api from '@utils/axios';
import kendoDatatableParams from '@helpers/kendoDatatableParams';
import { tagsPath, editTagPath, tagPath, taggingsTagPath } from 'routes';

import { renamePayload } from './renameParams';

// IP-15330: every request the tag settings screen makes, in one place.
//
// Every id-bearing helper is called as `({ id, format: 'json', _options: true })`.
// Both halves of that are load-bearing, and both were measured against the
// generated frontend/routes.js rather than assumed:
//
//   editTagPath(11, { format: 'json' })                 -> THROWS "missing required keys: id"
//   editTagPath({ id: 11, format: 'json' })             -> "/settings/tags/11/edit"   (.json SILENTLY DROPPED)
//   editTagPath({ id: 11, format: 'json', _options: true }) -> "/settings/tags/11/edit.json"
//
// These routes sit inside the optional `(:locale)` scope, so js-routes declares
// them as {locale:{}, id:{r:true}, format:{}}: a positional argument binds to
// `locale`, and without `_options` the object is read as positional params so
// `format` never reaches the format group. The dropped `.json` is the nastier of
// the two — the request succeeds, returns the HTML page, and axios hands back a
// string, so `tag` is truthy but has no countsByType and the drawer crashes on
// Object.entries(undefined). Mirrors apiInternalNotePath's call style.

export async function fetchTags({ page, sort, filters, signal }) {
  const { data } = await api.get(tagsPath({ format: 'json' }), {
    params: kendoDatatableParams({ page, sort, filters }),
    signal
  });

  return data;
}

export async function fetchTag(id) {
  const { data } = await api.get(editTagPath({ id, format: 'json', _options: true }));

  return data;
}

export async function renameTag(id, name) {
  const { data } = await api.patch(tagPath({ id, format: 'json', _options: true }), renamePayload(name));

  return data;
}

export async function removeTagFromType(id, taggableType) {
  const { data } = await api.delete(taggingsTagPath({ id, format: 'json', _options: true }), {
    params: { taggable_type: taggableType }
  });

  return data;
}

export async function deleteTag(id) {
  const { data } = await api.delete(tagPath({ id, format: 'json', _options: true }));

  return data;
}
